import React from 'react';

import WaterTank from './water-tank.svg?react';

function FarmbotWaterTankIcon() {
  return <WaterTank width={18} />;
}

export default FarmbotWaterTankIcon;
